/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import { contactGroupTableHead } from './tableHead';
import MaintainClientCustomNaviation from './maintainClientCustomNavigation';
import PlanContactForm from '../../../Plan/component/planContactForm';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { saveContactData } from '../../../Plan/store/actions';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { setTabValue } from '../../store/actions';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function MaintainTabs(props) {
  const {
    setErrorMessages,
    setShowError,
    showNameErr,
    showAddrErr,
    showCityErr,
    showStateErr,
    showZipErr,
    showPhoneErr,
    showEmailErr,
    clientData,
    ref,
    setContactErrors,
    fullScreenView,
    setFullScreenView,
    clientGroup,
    clientId,
    setIsFormChanged,
    onContactDirtyChange,
    setSuccessMessages,
    errorMessages,
    contactType,
    contactFormDirty,
    savePopup,
  } = props;
  const classes = useStyles();
  const tabValue = useSelector((state) => {
    return state.sharedState.ClientReducer.tabValue;
  });
  const [value, setValue] = useState(tabValue || 0);
  const frameworkComponents = {
    CustomNavigationComponent: MaintainClientCustomNaviation,
  };
  const gridHeight = fullScreenView ? '70vh' : 360;

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const dispatch = useDispatch();

  const contactDetails = useSelector((state) => {
    return state.sharedState.ClientReducer.contactDetails;
  });

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  useEffect(() => {
    if (contactDetails && contactDetails.length && contactDetails.length > 0) {
      dispatch(saveContactData(contactDetails[0]));
    } else {
      dispatch(saveContactData({}));
    }
  }, [contactDetails]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setTabValue(newValue));
  };

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      CLIENT_ID: `${clientData.clientId}`,
    });
  };

  return (
    <>
      <div className={classes.root}>
        {!fullScreenView && (
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="Client Group" {...a11yProps(0)} tabIndex={0} />
              <Tab label="Contact" {...a11yProps(1)} tabIndex={0} />
              {(showNameErr ||
                showAddrErr ||
                showCityErr ||
                showStateErr ||
                showZipErr ||
                showPhoneErr ||
                showEmailErr ||
                (errorMessages?.length > 0 &&
                  errorMessages.filter(
                    (x) =>
                      x === constantMessageData.NAME_REQUIRED ||
                      x === constantMessageData.CONTACT_TYPE_REQUIRED ||
                      x === constantMessageData.ADDRESS_LINE1_REQUIRED ||
                      x === constantMessageData.CITY_REQUIRED ||
                      x === constantMessageData.STATE_REQUIRED ||
                      x === constantMessageData.ZIP_REQUIRED ||
                      x === constantMessageData.ZIP4_REQUIRED ||
                      x === constantMessageData.PHONE_REQUIRED ||
                      x === constantMessageData.PHONE_INVALID_ERROR ||
                      x === constantMessageData.EMAIL_REQUIRED ||
                      x === constantMessageData.EMAIL_INVALID
                  ).length > 0)) && <span className="tab-error">!</span>}
            </Tabs>
          </AppBar>
        )}
        <TabPanel value={value} index={0}>
          <Grid
            gridHeight={gridHeight}
            rowData={
              clientGroup.length > 0
                ? clientGroup?.map((item) => ({
                    ...item,
                    clientId: clientId,
                    groupId: item?.clientGroupId?.groupId,
                    startDt: item?.clientGroupId?.startDt,
                    endDt: item?.endDt,
                  }))
                : []
            }
            columnDefs={contactGroupTableHead}
            onSelect={() => {}}
            frameworkComponents={frameworkComponents}
            data-testid="onEditingStopped"
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit={false}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            handleFullScreenViewClick={handleFullScreenViewClick}
            exportFile
            fileName="Client Group"
            handleViewHistory={handleViewHistory}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PlanContactForm
            ref={ref}
            setSuccessMessage={setSuccessMessages}
            keyId={clientData?.clientId}
            setContactErrors={setContactErrors}
            defaultValues={clientData}
            setErrorMessages={setErrorMessages}
            entityType="CLIENT"
            keyTypeCd="CLIENT"
            contactType={contactType}
            setShowError={setShowError}
            showNameErr={showNameErr}
            showAddrErr={showAddrErr}
            showCityErr={showCityErr}
            showStateErr={showStateErr}
            showZipErr={showZipErr}
            showPhoneErr={showPhoneErr}
            setIsFormChanged={setIsFormChanged}
            showEmailErr={showEmailErr}
            savePopup={savePopup}
            onContactDirtyChange={onContactDirtyChange}
            contactFormDirty={contactFormDirty}
          />
        </TabPanel>
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="CLIENT"
            keyValue={keyValue}
          />
        )}
      </div>
    </>
  );
}
